module.exports = __webpack_public_path__ + "media/images/iconClose__errorRed--dark-732978796aafd8cc4ef826cb8d926376.png";